import { render, staticRenderFns } from "./generateChart.vue?vue&type=template&id=8b5f4c96&scoped=true&"
import script from "./generateChart.vue?vue&type=script&lang=js&"
export * from "./generateChart.vue?vue&type=script&lang=js&"
import style0 from "./generateChart.vue?vue&type=style&index=0&id=8b5f4c96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5f4c96",
  null
  
)

export default component.exports